import { Component, Input } from '@angular/core';
import { TranslatePipe } from '../../../core/i18n/translate.pipe';
import { ErrorBlockComponent } from '@clinic-platform/ui-components';

@Component({
  selector: 'app-company-context-required',
  standalone: true,
  imports: [TranslatePipe, ErrorBlockComponent],
  template: `
    <lib-error-block
      variant="error"
      [message]="message | t"
    />
  `,
})
export class CompanyContextRequiredComponent {
  @Input() public message = 'error.settingsCompanyContextRequired';
}
